/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForItsm extends models.GovernanceConfigurationBase {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForItsm.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForItsm>): GovernanceConfigurationBaseForItsm {
        let obj = Object.assign(new GovernanceConfigurationBaseForItsm(), model);
        GovernanceConfigurationBaseForItsm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForItsm>): GovernanceConfigurationBaseForItsm {
        if (!model) return null;
        return GovernanceConfigurationBaseForItsm.newInstance(<GovernanceConfigurationBaseForItsm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForItsm) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForItsm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForItsm): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForItsm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
